import { ClaimPropertiesActionTypes, type ClaimPropertiesActions, type ClaimPropertiesKey } from './actions';

export const reducer = (state: ClaimPropertiesKey, action: ClaimPropertiesActions): ClaimPropertiesKey => {
  switch (action.type) {
    case ClaimPropertiesActionTypes.REFRESH:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
